export const WINDOW_OPTIONS = [
  { value: '7d', label: '7 days' },
  { value: '30d', label: '30 days' },
  { value: '90d', label: '90 days' },
  { value: '365d', label: '365 days' },
  { value: 'all', label: 'All time' },
];
export const DEFAULT_WINDOW = '90d';

const STORAGE_KEY = 'hyredocs.dashboard.window';

export function readStoredWindow() {
  try {
    const v = window.localStorage.getItem(STORAGE_KEY);
    return WINDOW_OPTIONS.some((o) => o.value === v) ? v : DEFAULT_WINDOW;
  } catch {
    return DEFAULT_WINDOW;
  }
}

export function storeWindow(value) {
  try {
    window.localStorage.setItem(STORAGE_KEY, value);
  } catch {
    /* private mode / blocked storage — the choice just won't persist */
  }
}

export default function WindowSelector({ value, onChange, disabled }) {
  return (
    <div className="dash-segmented" role="group" aria-label="Time window" data-testid="dashboard-window-selector">
      {WINDOW_OPTIONS.map((o) => (
        <button
          key={o.value}
          type="button"
          aria-pressed={value === o.value}
          disabled={disabled}
          onClick={() => onChange(o.value)}
          data-testid={`dashboard-window-${o.value}`}
        >
          {o.label}
        </button>
      ))}
    </div>
  );
}
